import {connect} from 'react-redux';
import EditPDF from './EditPDF';
import {editPDFPages,editOrderPDFPages} from '../../../../../modules/Inspection/actions/files/editPDFPages';

export default connect(
  null,
  {editPDFPages, editOrderPDFPages}
)(EditPDF);
